import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "./index.css";
import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useRef, forwardRef, useMemo, Fragment, useCallback, useState, useEffect } from 'react';
import { Button } from '@design-system/button';
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var AccordionContent = function AccordionContent(_ref2) {
  var semanticVariant = _ref2.semanticVariant,
    index = _ref2.index,
    children = _ref2.children,
    itemsLength = _ref2.itemsLength,
    isOpen = _ref2.isOpen;
  var contentItemHeight = useRef([]);
  var ContentTag = semanticVariant === 'dl' ? 'dd' : 'div';
  return jsx(ContentTag, Object.assign({
    className: classNames('cds-accordion__item-content-wrapper', {
      'cds-accordion__item-content-wrapper--last': index === itemsLength - 1,
      'cds-accordion__item-content-wrapper--open': isOpen
    }),
    style: {
      height: isOpen ? contentItemHeight.current[index] : 0
    },
    "aria-hidden": !isOpen
  }, {
    children: jsx("div", Object.assign({
      ref: function ref(child) {
        if (contentItemHeight.current) {
          contentItemHeight.current[index] = child === null || child === void 0 ? void 0 : child.offsetHeight;
        }
      },
      className: classNames('cds-accordion__item-content', {
        'cds-accordion__item-content--open': isOpen
      })
    }, {
      children: children
    }))
  }));
};
var DangerouslySetInnerHtml = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var html = _ref.html,
    _ref$element = _ref.element,
    Component = _ref$element === void 0 ? 'div' : _ref$element,
    className = _ref.className,
    onClick = _ref.onClick,
    children = _ref.children;
  return html ? jsx(Component, Object.assign({}, {
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: html
    },
    className: className,
    onClick: onClick,
    children: children
  })) : null;
});
var AccordionTitle = function AccordionTitle(_a) {
  var isOpen = _a.isOpen,
    _a$headlineTag = _a.headlineTag,
    headlineTag = _a$headlineTag === void 0 ? Fragment : _a$headlineTag,
    _a$openIcon = _a.openIcon,
    openIcon = _a$openIcon === void 0 ? {
      icon: 'add'
    } : _a$openIcon,
    _a$closeIcon = _a.closeIcon,
    closeIcon = _a$closeIcon === void 0 ? {
      icon: 'close'
    } : _a$closeIcon,
    semanticVariant = _a.semanticVariant,
    onToggle = _a.onToggle,
    title = _a.title,
    rest = __rest(_a, ["isOpen", "headlineTag", "openIcon", "closeIcon", "semanticVariant", "onToggle", "title"]);
  var TitleTag = useMemo(function () {
    return semanticVariant === 'dl' ? 'dt' : 'div';
  }, [semanticVariant]);
  var HeadlineTag = useMemo(function () {
    return semanticVariant === 'dl' ? Fragment : headlineTag;
  }, [headlineTag, semanticVariant]);
  return jsx(TitleTag, Object.assign({
    className: "cds-accordion__opener"
  }, {
    children: jsx(HeadlineTag, {
      children: jsx(Button, Object.assign({
        iconPrefix: {
          props: {
            icon: !isOpen ? openIcon.icon : closeIcon.icon,
            classNameContainer: "accordion-item__".concat(isOpen ? 'close' : 'open', "-icon"),
            isWrapped: true
          }
        },
        variant: "subtle",
        size: "large",
        onClick: onToggle,
        "aria-expanded": isOpen,
        className: classNames({
          active: isOpen
        })
      }, rest, {
        children: jsx(DangerouslySetInnerHtml, {
          html: title
        })
      }))
    })
  }));
};
var AccordionItem = function AccordionItem(_a) {
  var semanticVariant = _a.semanticVariant,
    indexValue = _a.indexValue,
    isOpen = _a.isOpen,
    itemsLength = _a.itemsLength,
    headlineTag = _a.headlineTag,
    openIcon = _a.openIcon,
    closeIcon = _a.closeIcon,
    title = _a.title,
    className = _a.className,
    handleTogglerAccordionItem = _a.handleTogglerAccordionItem,
    children = _a.children,
    disabled = _a.disabled,
    rest = __rest(_a, ["semanticVariant", "indexValue", "isOpen", "itemsLength", "headlineTag", "openIcon", "closeIcon", "title", "className", "handleTogglerAccordionItem", "children", "disabled"]);
  var Tag = useMemo(function () {
    return semanticVariant === 'div' ? 'section' : 'div';
  }, [semanticVariant]);
  var handleKeyDown = useCallback(function (e) {
    if (e.key === 'Enter') {
      handleTogglerAccordionItem();
    }
  }, [handleTogglerAccordionItem]);
  return jsxs(Tag, Object.assign({
    className: classNames('cds-accordion__item', className, {
      active: isOpen,
      'cds-accordion__item--disabled': disabled
    }),
    onKeyDown: handleKeyDown
  }, rest, {
    children: [jsx(AccordionTitle, {
      tabIndex: -1,
      isOpen: isOpen,
      headlineTag: headlineTag,
      openIcon: openIcon,
      closeIcon: closeIcon,
      semanticVariant: semanticVariant,
      onToggle: handleTogglerAccordionItem,
      title: title,
      disabled: disabled
    }), jsx(AccordionContent, Object.assign({
      semanticVariant: semanticVariant,
      index: indexValue,
      itemsLength: itemsLength,
      isOpen: isOpen
    }, {
      children: children
    }))]
  }));
};
var AccordionWrapper = function AccordionWrapper(_ref3) {
  var items = _ref3.items,
    Tag = _ref3.semanticVariant,
    headlineTag = _ref3.headlineTag,
    openIcon = _ref3.openIcon,
    closeIcon = _ref3.closeIcon,
    selectedIndex = _ref3.selectedIndex,
    handleTogglerAccordionItem = _ref3.handleTogglerAccordionItem;
  return jsx(Tag, {
    children: items.map(function (_a, index) {
      var title = _a.title,
        children = _a.children,
        rest = __rest(_a, ["title", "children"]);
      return jsx(AccordionItem, Object.assign({
        title: title,
        semanticVariant: Tag,
        indexValue: index,
        itemsLength: items.length,
        isOpen: selectedIndex.some(function (i) {
          return i === index;
        }),
        headlineTag: headlineTag,
        openIcon: openIcon,
        closeIcon: closeIcon,
        handleTogglerAccordionItem: handleTogglerAccordionItem(index),
        tabIndex: 0
      }, rest, {
        children: children
      }), title);
    })
  });
};
var noJsCss = "\n.cds-accordion__item-content-wrapper {\n  height: auto !important;\n}\n\n.cds-accordion__item-content {\n  opacity: 1 !important;\n}\n\n.cds-accordion__opener .icon__prefix {\n  display: none !important;\n}\n\n.cds-accordion__opener .icon__suffix {\n  display: none !important;\n}\n";
var Accordion = forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    semanticVariant = _ref4.semanticVariant,
    expandedIndex = _ref4.expandedIndex,
    items = _ref4.items,
    _ref4$expandVariant = _ref4.expandVariant,
    expandVariant = _ref4$expandVariant === void 0 ? 'multiple' : _ref4$expandVariant,
    headlineTag = _ref4.headlineTag,
    openIcon = _ref4.openIcon,
    closeIcon = _ref4.closeIcon,
    _ref4$viewVariant = _ref4.viewVariant,
    viewVariant = _ref4$viewVariant === void 0 ? 'card' : _ref4$viewVariant,
    onChange = _ref4.onChange;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  var onCloseAccordionItem = useCallback(function (index) {
    if (selectedIndex.some(function (i) {
      return i === index;
    })) {
      setSelectedIndex(_toConsumableArray(selectedIndex.filter(function (el) {
        return el !== index;
      })));
    }
  }, [selectedIndex]);
  var handleTogglerAccordionItem = useCallback(function (index) {
    return function () {
      if (onChange) onChange(index, !selectedIndex.some(function (i) {
        return i === index;
      }));
      if (expandVariant === 'single') {
        return selectedIndex[0] === index ? onCloseAccordionItem(index) : setSelectedIndex([index]);
      }
      if (selectedIndex.some(function (i) {
        return i === index;
      })) {
        return onCloseAccordionItem(index);
      }
      return setSelectedIndex([].concat(_toConsumableArray(selectedIndex), [index]));
    };
  }, [expandVariant, selectedIndex, onChange, onCloseAccordionItem]);
  useEffect(function () {
    if (expandedIndex) {
      var disabledItems = items.map(function (el, index) {
        return el.disabled && index;
      }).filter(Boolean);
      var filteredExpandedIndex = expandedIndex.filter(function (el) {
        return !disabledItems.includes(el);
      });
      if (expandVariant === 'single' && filteredExpandedIndex.length) {
        setSelectedIndex([filteredExpandedIndex[0]]);
      }
      if (expandVariant === 'multiple') {
        setSelectedIndex(filteredExpandedIndex);
      }
    }
  }, [expandVariant, expandedIndex, items]);
  return jsxs("div", Object.assign({
    ref: ref,
    className: classNames('cds-accordion', "cds-accordion__".concat(viewVariant), className)
  }, {
    children: [jsx(AccordionWrapper, {
      items: items,
      semanticVariant: semanticVariant,
      selectedIndex: selectedIndex,
      headlineTag: headlineTag,
      openIcon: openIcon,
      closeIcon: closeIcon,
      handleTogglerAccordionItem: handleTogglerAccordionItem,
      viewVariant: viewVariant
    }), jsx("noscript", {
      children: jsx("style", {
        children: noJsCss
      })
    })]
  }));
});
export { Accordion };